import { create } from 'zustand';

import type { TrangThaiKenh } from '../lib/repositories/su-kien.repository';

/**
 * Trạng thái kênh sự kiện của người đang đăng nhập.
 *
 * `tat`: không mở kênh nào (dữ liệu mẫu, chưa đăng nhập). Các trạng thái khác
 * đến từ lớp vận chuyển (`lib/api/su-kien.ts`) qua `useKenhSuKien`.
 */
export type TrangThaiKenhSuKien = TrangThaiKenh | 'tat';

interface KenhSuKienState {
  trangThai: TrangThaiKenhSuKien;
}

export const useKenhSuKienStore = create<KenhSuKienState>(() => ({ trangThai: 'tat' }));
